/**
 * Static UI constants for the Dev Guide screen. Document content itself is no
 * longer stored here — it is fetched from the S3-backed Lambda via
 * useDevGuideData. Only appearance/theme constants remain.
 */

/** Appearance options for the theme toggle (right rail). */
export const THEME_MODES = [
    { key: "light", label: "Light" },
    { key: "dark", label: "Dark" },
    { key: "auto", label: "Auto" },
];

/** sessionStorage key so the chosen appearance survives route changes. */
export const THEME_STORAGE_KEY = "devguide-theme";
